import { useUserStore } from "@/stores/user";
import { useOrganizationStore } from "@/stores/organization";
import { useEffect, useState } from "react";

export function useStoreHydration() {
  const [hydrated, setHydrated] = useState(false);
  const userHydrated = useUserStore((state) => state.hydrated);
  const orgHydrated = useOrganizationStore((state) => state.hydrated);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const isHydrated = userHydrated && orgHydrated;
    setHydrated(isHydrated);
  }, [userHydrated, orgHydrated]);

  return hydrated;
}
